import api from "shared/api";
import { BaseApiService } from "shared/api";

class GoogleSearchService extends BaseApiService {
  getTravelPlaces(inputValue) {
    return api.get(
      `${this.ENDPOINTS.google_search.travel_places}?name=${inputValue}`
    );
  }
}

export default new GoogleSearchService();
